import React, { useRef, useState, useEffect, useContext } from "react";
import * as S from "./styles";
import ConveniosSVG from "../../assets/navbar/Convenios_on_light_blue.svg";
import desmaskIfNumber from "../../utils/desmaskIfNumber";
import api from "../../services/api";
import convenio from "../../services/convenio";

import { Formik, Form, Field } from "formik";

import InputText from "../../components/InputText";
import Button from "../../components/Button";
import Navbar from "../../components/Navbar";

import { useParams } from "react-router-dom";

import { toast } from "react-toastify";
import firstSchema from "./validations/schemaValidation";
import history from "../../utils/history";

import ListLog from "../../components/ListLog";
import Skeleton from "../../components/skeleton";
import { Context } from "../../context/globalContext";
import PoPup from "../../components/PopUp";
import TextArea from "../../components/TextArea";

import { IoChevronUp } from "react-icons/io5";
import ButtonV2 from "../../components/Button-v2";
import { GoTopoButtonWrapper } from "../../styles/commonStyle";

export default function ConvenioRegistration() {
  const formRef = useRef(null);
  const { id } = useParams();
  const [formData, setFormData] = useState();
  const [convenioId, setConvenioId] = useState(null);
  const [initialState, setInitialState] = useState({
    id: null,
    pessoaId: null,
    cpfCnpj: "",
    nome: "",
    nomeFantasia: "",
    municipio: "",
    uf: "",
    nomeConvenio: "",
    codigoIntegracaoFinanceira: "",
    status: true,
    observacao: "",
  });
  const [editingPerson, setEditingPerson] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [userSelected, setUserSelected] = useState({ id: null, cpf: null });
  const globalContext = useContext(Context);

  async function onBlurCnpj(cnpj) {
    if (cnpj.length !== 14) {
      return;
    }
    globalContext.setIsLoading(false);

    try {
      const response = await api.get(
        `api/pessoa/buscar?cpfCnpjOuNome=${cnpj}&tipoPessoa=PESSOA_JURIDICA`
      );
      if (
        response?.data &&
        (response.status === 201 || response.status === 200)
      ) {
        const content = response?.data?.content;
        const enderecos = content?.[0]?.enderecos;
        let municipio =
          content?.[0]?.enderecos?.[0]?.municipio?.descricao?.toUpperCase();
        let uf =
          content?.[0]?.enderecos?.[0]?.municipio?.estado?.nome?.toUpperCase();
        if (enderecos && enderecos.length > 1) {
          municipio =
            content?.[0]?.enderecos?.[
              enderecos?.length - 1
            ]?.municipio?.descricao?.toUpperCase();
          uf =
            content?.[0]?.enderecos?.[
              enderecos?.length - 1
            ]?.municipio?.estado?.nome?.toUpperCase();
        }

        setInitialState({
          ...initialState,
          cpfCnpj: cnpj,
          pessoaId: content?.[0]?.id,
          nome: content?.[0]?.nome,
          nomeFantasia: content?.[0]?.nomeFantasia,
          municipio: municipio,
          uf: uf,
        });
      } else if (!response) {
        setInitialState({
          ...initialState,
          cpfCnpj: cnpj,
          pessoaId: null,
          nome: "",
          nomeFantasia: "",
          municipio: "",
          uf: "",
        });
        toast.error(
          "Erro ao buscar os dados deste cnpj, tente novamente mais tarde!"
        );
      }
    } catch (err) {
      setInitialState({
        ...initialState,
        cpfCnpj: cnpj,
        pessoaId: null,
        nome: "",
        nomeFantasia: "",
        municipio: "",
        uf: "",
      });
      if (err?.response?.data?.message) {
        toast.error(err?.response?.data?.message);
      } else {
        toast.error(
          "Erro ao buscar os dados deste cnpj, tente novamente mais tarde!"
        );
      }
    } finally {
      globalContext.setIsLoading(false);
    }
  }

  async function getDataByUserId() {
    globalContext.setIsLoading(true);
    await convenio
      .listData(id)
      .then(async (ev) => {
        const data = ev?.data;
        if (data) {
          const enderecos = data?.pessoa?.enderecos;
          let municipio =
            data?.pessoa?.enderecos?.[0]?.municipio?.descricao?.toUpperCase();
          let uf =
            data?.pessoa?.enderecos?.[0]?.municipio?.estado?.nome?.toUpperCase();
          if (enderecos && enderecos.length > 1) {
            municipio =
              data?.pessoa?.enderecos?.[
                enderecos?.length - 1
              ]?.municipio?.descricao?.toUpperCase();
            uf =
              data?.pessoa?.enderecos?.[
                enderecos?.length - 1
              ]?.municipio?.estado?.nome?.toUpperCase();
          }

          const cpfCnpj = data?.pessoa?.cpfCnpj;
          const _id = data?.id;
          const pessoaId = data?.pessoa?.id;
          const nome = data?.pessoa?.nome;
          const nomeFantasia = data?.pessoa?.nomeFantasia;
          const codigoIntegracaoFinanceira = data?.codIntegracaoFin;
          const codigoIntegracaoEm = data?.codIntegracaoEm;
          const nomeSequenceIntegracaoEmFilial =
            data?.nomeSequenceIntegracaoEmFilial;
          const nomeSequenceIntegracaoEmAgente =
            data?.nomeSequenceIntegracaoEmAgente;
          const nomeConvenio = data?.nomeConvenio;

          setInitialState({
            ...data,
            cpfCnpj: cpfCnpj,
            id: _id,
            pessoaId: pessoaId,
            nome: nome,
            nomeFantasia: nomeFantasia,
            municipio: municipio,
            uf: uf,
            codigoIntegracaoFinanceira: codigoIntegracaoFinanceira,
            codigoIntegracaoEm: codigoIntegracaoEm,
            nomeSequenceIntegracaoEmFilial: nomeSequenceIntegracaoEmFilial,
            nomeSequenceIntegracaoEmAgente: nomeSequenceIntegracaoEmAgente,
            nomeConvenio: nomeConvenio,
            observacao: data?.observacao,
          });
        }
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          toast.error(err?.response?.data?.message);
        } else {
          toast.error(
            "Erro ao buscar dados, verifique os dados e tente novamente!"
          );
        }
      })
      .finally(() => globalContext.setIsLoading(false));
  }

  useEffect(() => {
    if (id) {
      getDataByUserId();
    }

    id !== undefined && setEditingPerson(true);
  }, [id]);

  const sendData = async (dataForm) => {
    if (!dataForm.pessoaId || dataForm.pessoaId === null) {
      toast.error("Digite um cnpj válido.");
      return;
    }
    globalContext.setIsLoading(true);

    const dataSending = {
      id: dataForm?.id,
      nomeConvenio: dataForm?.nomeConvenio,
      codIntegracaoFin: dataForm?.codigoIntegracaoFinanceira,
      codIntegracaoEm: dataForm?.codigoIntegracaoEm,
      nomeSequenceIntegracaoEmFilial: dataForm?.nomeSequenceIntegracaoEmFilial,
      nomeSequenceIntegracaoEmAgente: dataForm?.nomeSequenceIntegracaoEmAgente,
      pessoa: {
        id: dataForm.pessoaId,
      },
      status: true,
      observacao: dataForm.observacao,
    };

    const handleEditing = async () => {
      try {
        const response = await convenio.editingData(dataForm?.id, dataSending);
        if (response && (response.status === 201 || response.status === 200)) {
          getDataByUserId();
          toast.success("Dados atualizados com sucesso!");
        } else if (!response) {
          toast.error(
            "Erro ao salvar dados, verifique os dados e tente novamente!"
          );
        }
      } catch (err) {
        if (err?.response?.data?.message) {
          toast.error(err?.response?.data?.message);
        } else {
          toast.error(
            "Erro ao salvar dados, verifique os dados e tente novamente!"
          );
        }
      } finally {
        globalContext.setIsLoading(false);
      }
    };

    const handleCreate = async () => {
      try {
        const response = await convenio.sendData(dataSending);
        if (response && (response.status === 201 || response.status === 200)) {
          toast.success("Dados cadastrados com sucesso!");
        } else if (!response) {
          toast.error(
            "Erro ao salvar dados, verifique os dados e tente novamente!"
          );
        }
      } catch (err) {
        if (err?.response?.data?.message) {
          toast.error(err?.response?.data?.message);
        } else {
          toast.error(
            "Erro ao salvar dados, verifique os dados e tente novamente!"
          );
        }
      } finally {
        globalContext.setIsLoading(false);
      }
    };

    if (id) {
      handleEditing();
    } else {
      handleCreate();
    }
  };

  const handleSubmit = () => {
    if (formRef.current) {
      if (formRef.current.isValid) {
        sendData(formRef.current.values);
      }
    }
  };

  useEffect(() => {
    Object.keys(formRef.current.values).length >= 1
      ? setFormData(true)
      : setFormData(false);
  }, [formRef, formData]);

  return (
    <>
      <Navbar className="navbar" />
      <S.Wrapper>
        <S.Header>
          <S.BoxUser>
            <S.Image src={ConveniosSVG} />
            <div>
              <S.Title>Convênios</S.Title>
              <S.Description>Cadastro geral de convênios</S.Description>
            </div>
          </S.BoxUser>
        </S.Header>

        <S.Content>
          <Formik
            innerRef={formRef}
            initialValues={initialState}
            enableReinitialize={true}
            validationSchema={firstSchema}
            onSubmit={(values) => handleSubmit}
          >
            {({ errors, touched, values, setFieldValue }) => (
              <Form>
                <Field
                  name="cpfCnpj"
                  id="cpfCnpj"
                  render={({ field }) =>
                    !globalContext.isLoading ? (
                      <InputText
                        {...field}
                        type="text"
                        width="50%"
                        label="CNPJ*:"
                        maskChar=""
                        mask="99.999.999/9999-99"
                        currency="false"
                        disabled={id && initialState.status === false}
                        error={errors.cpfCnpj && touched.cpfCnpj}
                        onChange={(e) => {
                          onBlurCnpj(desmaskIfNumber(e.target.value));
                          setFieldValue("cpfCnpj", e.target.value);
                        }}
                      />
                    ) : (
                      <Skeleton type="input" />
                    )
                  }
                />
                <p>{errors.cpfCnpj}</p>
                <S.InputBox>
                  <Field
                    name="nome"
                    id="nome"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          {...field}
                          type="text"
                          label="Razão social*:"
                          currency="false"
                          error={errors.nome && touched.nome}
                          disabled
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                </S.InputBox>

                <S.InputBox>
                  <Field
                    name="nomeFantasia"
                    id="nomeFantasia"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          {...field}
                          label="Nome fantasia*:"
                          currency="false"
                          error={errors.nomeFantasia && touched.nomeFantasia}
                          disabled
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                </S.InputBox>

                <S.InputBox>
                  <Field
                    name="municipio"
                    id="municipio"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          label="Cidade:"
                          {...field}
                          disabled
                          currency="false"
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />

                  <Field
                    name="uf"
                    id="uf"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          label="Estado:"
                          {...field}
                          disabled
                          currency="false"
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                </S.InputBox>
                <S.InputBox>
                  <Field
                    name="nomeConvenio"
                    id="nomeConvenio"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          {...field}
                          disabled={id && initialState.status === false}
                          label="Nome do convênio:"
                          type="text"
                          currency="false"
                          onChange={(e) => {
                            setInitialState({
                              ...initialState,
                              nomeConvenio: e.target.value,
                            });
                          }}
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                </S.InputBox>

                <S.InputBox>
                  <Field
                    name="codigoIntegracaoFinanceira"
                    id="codigoIntegracaoFinanceira"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          {...field}
                          disabled={id && initialState.status === false}
                          label="Código de Integração SGS:"
                          currency="false"
                          onChange={(e) => {
                            setInitialState({
                              ...initialState,
                              codigoIntegracaoFinanceira: e.target.value,
                            });
                          }}
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                </S.InputBox>

                <S.InputBox>
                  <Field
                    name="codigoIntegracaoEm"
                    id="codigoIntegracaoEm"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          {...field}
                          disabled={id && initialState.status === false}
                          label="Código de Integração EM:"
                          currency="false"
                          onChange={(e) => {
                            setInitialState({
                              ...initialState,
                              codigoIntegracaoEm: e.target.value,
                            });
                          }}
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                </S.InputBox>

                <S.InputBox>
                  <Field
                    name="nomeSequenceIntegracaoEmFilial"
                    id="nomeSequenceIntegracaoEmFilial"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          {...field}
                          disabled={id && initialState.status === false}
                          label="Nome da sequence no Postgres do código de filial no EM:"
                          type="text"
                          currency="false"
                          onChange={(e) => {
                            setInitialState({
                              ...initialState,
                              nomeSequenceIntegracaoEmFilial: e.target.value,
                            });
                          }}
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                </S.InputBox>

                <S.InputBox>
                  <Field
                    name="nomeSequenceIntegracaoEmAgente"
                    id="nomeSequenceIntegracaoEmAgente"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          {...field}
                          disabled={id && initialState.status === false}
                          label="Nome da sequence no Postgres do código de agente no EM:"
                          type="text"
                          currency="false"
                          onChange={(e) => {
                            setInitialState({
                              ...initialState,
                              nomeSequenceIntegracaoEmAgente: e.target.value,
                            });
                          }}
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                </S.InputBox>

                <S.TextAreaBox>
                  <Field
                    name="observacao"
                    id="observacao"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <TextArea
                          {...field}
                          type="text"
                          label="Observação:"
                          onChange={(e) => {
                            setFieldValue("observacao", e.target.value);
                          }}
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                </S.TextAreaBox>
              </Form>
            )}
          </Formik>
          <S.ButtonContainer>
            <Button button="primary" onClick={history.goBack}>
              Voltar
            </Button>
            {id && initialState.status === true ? (
              <Button
                button="primary"
                className="inativar"
                onClick={() => {
                  setPopupOpen(true);
                  setUserSelected({
                    id: initialState.id,
                    cpf: initialState.cpfCnpj,
                  });
                }}
              >
                Inativar
              </Button>
            ) : (
              <></>
            )}
            <Button button="primary" onClick={() => handleSubmit()}>
              {id && initialState.status === false
                ? "Ativar cadastro"
                : "Salvar cadastro"}
            </Button>
          </S.ButtonContainer>
        </S.Content>
        <S.Content>
          {initialState?.id && (
            <ListLog entidadeId={initialState.id} nomeEntidade="Convenio" />
          )}
          <GoTopoButtonWrapper>
            <ButtonV2
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              height="32px"
              leftIcon={IoChevronUp}
            >
              Topo
            </ButtonV2>
          </GoTopoButtonWrapper>
        </S.Content>
      </S.Wrapper>
      {popupOpen && (
        <PoPup
          setIsLoading={globalContext.setIsLoading}
          setOpenPopup={setPopupOpen}
          updateList={getDataByUserId}
          userSelected={userSelected}
          endPoint="/api/convenio/"
          useMask="##.###.###/####-##"
          inativar={true}
          showCpfCnpj={true}
          textExclude={"Você deseja realmente inativar este convênio?"}
          messageFailed={"Error ao inativar o convênio com o CNPJ"}
          messageSuccess={"Sucesso ao inativar o convênio"}
        />
      )}
    </>
  );
}
